// extracted by mini-css-extract-plugin
export default {"container":"Dock_container__li2V2","draft_container":"Dock_draft_container__tj9Wh"};